import UploadSingle from '.';
import { useSignedUrl } from '@/helpers/signedUrl';
import React from 'react';

/**
 * UploadSingle for a value stored as a Firebase path rather than a URL.
 * The path is exchanged for a short-lived signed URL for display only; the
 * value handed back by `onChange` is untouched, so saving still posts the path.
 */
const SignedUploadSingle = ({ imageUrlSelected, ...props }) => (
  <UploadSingle {...props} imageUrlSelected={useSignedUrl(imageUrlSelected)} />
);

export default SignedUploadSingle;
